<template>
	<keep-alive>
		<div>
			<div class="card-body">
				<p v-if="windowWidth >= mobileBreakpoint">
					Błyskawicznie i bez dodatkowych opłat
				</p>
				<div v-if="showMTransfer" class="transfer-radio">
					<input
						type="radio"
						name="FastPaymentType"
						id="FastPaymentType2"
						value="2"
						v-model="fastPaymentType"
					/>
					<label for="FastPaymentType2">
						<span>
							<img
								src="images/transfer-mtransfer.jpg?v-2"
								alt="mTransfer"
							/>
						</span>
						Jeśli posiadasz konto w mBanku
					</label>
				</div>
				<div v-if="showPaynow" class="transfer-radio">
					<input
						type="radio"
						name="FastPaymentType"
						id="FastPaymentType4"
						value="4"
						v-model="fastPaymentType"
					/>

					<label for="FastPaymentType4">
						<span>
							<img
								class="mt-2 paynow-logo"
								src="images/logo-paynow.png"
								alt="paynow"
							/>
						</span>
						Jeśli posiadasz konto w innym banku
					</label>
				</div>
				<div
					v-if="
						currentUser &&
						currentUser.sso &&
						sourceAccounts.length > 1
					"
					class="position-amount-input"
				>
					<v-select-2
						:label="'Rachunek do zasilenia'"
						:list="sourceAccounts"
						:value="sourceAccountValue"
						@input="setAccountValue($event.account)"
					/>
				</div>
				<div class="position-amount-input">
					<div class="input" style="width: 100%">
						<input
							:class="[{ filled: amountFilled }]"
							:maxlength="11"
							id="Amount"
							@keyup="commitAmount($event)"
							v-model="currentAmmount"
							autocomplete="off"
						/>
						<label for="Amount">Kwota do wpłaty PLN</label>
					</div>
				</div>
				<div class="checkbox">
					<input
						v-model="acceptation"
						type="checkbox"
						id="TransferAcceptation"
					/>
					<label for="TransferAcceptation">
						Akceptuję
						<a
							href="https://www.mforex.pl/regulaminy"
							target="_blank"
							>regulamin</a
						>
						szybkich wpłat w mForex
					</label>
				</div>
			</div>
			<div class="card-footer">
				<button
					@click="submitFastPayment()"
					type="button"
					class="btn btn-primary"
					:disabled="disabledPaymentButton || getPaymentLoadingButton"
				>
					<span
						v-if="getPaymentLoadingButton"
						class="loader-button"
					></span>
					wpłata
				</button>
			</div>
		</div>
	</keep-alive>
</template>

<script>
import { mapGetters } from 'vuex';
import { getDictionaryItem } from '@/mixins/get-dictionary-item';

export default {
	data() {
		return {
			disabledPaymentButton: true,
			correctAmmount: false,
			currentAmmount: null,
			amountFilled: false,
			wrongAmounts: [null, '', '0', '0,', '00', '0,0', '0,00', '0,000'],
		};
	},
	mixins: [getDictionaryItem],
	props: {
		transferTypeId: {
			type: Number,
			required: false,
			default: 2,
		},
	},
	methods: {
		setAccountValue(value) {
			this.$store.commit('setAccountNumber', value);
		},
		async submitFastPayment() {
			if (this.getPaymentLoadingButton) return;
			this.$store.commit('setPaymentLoadingButton', true);
			try {
				await this.$store.dispatch('fastPayment');
			} catch (err) {
				this.$store.commit('setPaymentLoadingButton', false);
			}
		},
		toggleSubmitButton() {
			const user = this.$store.getters.getCurrentUser;
			if (
				this.acceptation &&
				this.fastPaymentType &&
				this.correctAmmount &&
				(user && user.sso && this.sourceAccounts.length > 1
					? this.$store.getters.getAccountNumber
					: true)
			) {
				this.disabledPaymentButton = false;
			} else {
				this.disabledPaymentButton = true;
			}
		},
		commitAmount(e) {
			let currencyAmount = e.target.value
					.replace('.', ',')
					.replace(/([^0-9,.])/g, ''),
				comaIndex = currencyAmount.indexOf(','),
				comaCount = (currencyAmount.match(/,/g) || []).length;

			if (comaCount === 1) {
				currencyAmount = currencyAmount.slice(0, comaIndex + 3);
			} else if (comaCount > 1) {
				currencyAmount = currencyAmount.slice(
					0,
					currencyAmount.lastIndexOf(',')
				);
			}

			this.$store.commit('setAmount', currencyAmount);
			this.currentAmmount = currencyAmount;
			this.isFilled();

			if (!this.wrongAmounts.includes(currencyAmount)) {
				this.correctAmmount = true;
				this.$store.commit('setDisplayFormFastPayment', true);
				this.$store.commit('setDisplayFormPayout', false);
				this.$store.commit('setDisplayFormAccounts', false);
			} else this.correctAmmount = false;
		},
		isFilled() {
			if (this.currentAmmount && this.currentAmmount.length > 0)
				this.amountFilled = true;
			else this.amountFilled = false;
		},
	},
	computed: {
		fastPaymentType: {
			get() {
				return this.$store.getters.getFastPaymentType
					? this.$store.getters.getFastPaymentType
					: false;
			},
			set(value) {
				this.$store.commit('setFastPaymentType', value);
			},
		},
		accountNumberValue: {
			get() {
				return this.$store.getters.getAccountNumber || null;
			},
			set(value) {
				this.$store.commit('setAccountNumber', value);
			},
		},
		sourceAccounts() {
			return this.$store.getters.getPayout
				? this.$store.getters.getPayout.sourceAccounts
					? this.$store.getters.getPayout.sourceAccounts
					: []
				: [];
		},
		sourceAccountValue() {
			return this.getDictionaryItem(
				this.sourceAccounts,
				'text',
				'account',
				this.accountNumberValue
			);
		},
		acceptation: {
			get() {
				return this.$store.getters.getAcceptation
					? this.$store.getters.getAcceptation
					: false;
			},
			set(value) {
				this.$store.commit('setAcceptation', value);
			},
		},
		windowWidth() {
			return this.$store.getters.getWindowWidth;
		},
		...mapGetters({
			mobileBreakpoint: 'getMobileBreakpoing',
			showMTransfer: 'getShowMTransfer',
			showPaynow: 'getShowPaynow',
			currentUser: 'getCurrentUser',
			getPaymentLoadingButton: 'getPaymentLoadingButton',
		}),
		user() {
			return this.$store.getters.getUser;
		},
	},
	watch: {
		correctAmmount(newVal, oldVal) {
			if (newVal !== oldVal) this.toggleSubmitButton();
		},
	},

	beforeMount() {
		this.toggleSubmitButton();
	},
	mounted() {
		// Odznaczenie wcześniej wybranych płatności przy załadowaniu komponentu
		this.$store.commit('setFastPaymentType', null);
		this.$store.commit('setAcceptation', false);

		this.isFilled();
	},
	updated() {
		this.toggleSubmitButton();
	},
};
</script>
